import { Card } from "@/components/ui/card";
import {
  PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, Tooltip, Legend,
  ResponsiveContainer,
} from "recharts";

const TYPES = ["Refinance", "HELOC", "Purchase", "Reverse Mortgage", "Unknown"];
const COLOR = {
  Refinance: "#059669",
  HELOC: "#D4AF37",
  Purchase: "#2563eb",
  "Reverse Mortgage": "#7c3aed",
  Unknown: "#94a3b8",
};

export default function OpportunityCharts({ breakdown = [], runs = [] }) {
  const pie = (breakdown || []).filter((d) => d.count > 0);
  const total = pie.reduce((s, d) => s + d.count, 0);
  const presentTypes = TYPES.filter((t) => (runs || []).some((r) => r[t] > 0));

  if (total === 0) {
    return (
      <Card className="p-6 text-center text-sm text-slate-500" data-testid="opportunity-charts-empty">
        No leads yet — run breakdown charts appear here once you generate prospects.
      </Card>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2" data-testid="opportunity-charts">
      <Card className="p-5">
        <h3 className="mb-1 font-display font-bold text-slate-900">Opportunity Mix</h3>
        <p className="mb-2 text-xs text-slate-500">Share of leads by mortgage opportunity.</p>
        <div className="h-64" data-testid="opportunity-pie">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie data={pie} dataKey="count" nameKey="type" cx="50%" cy="50%"
                   innerRadius={55} outerRadius={85} paddingAngle={2}>
                {pie.map((d) => <Cell key={d.type} fill={COLOR[d.type] || COLOR.Unknown} />)}
              </Pie>
              <Tooltip formatter={(v, n) => [`${v} (${Math.round((v / total) * 100)}%)`, n]} />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </Card>

      <Card className="p-5">
        <h3 className="mb-1 font-display font-bold text-slate-900">Leads per Run</h3>
        <p className="mb-2 text-xs text-slate-500">Refi vs HELOC vs Purchase for each recent run.</p>
        <div className="h-64" data-testid="opportunity-bars">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={runs} margin={{ top: 8, right: 8, left: -18, bottom: 0 }}>
              <XAxis dataKey="run" tick={{ fontSize: 11 }} interval={0} angle={-12} textAnchor="end" height={48} />
              <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
              <Tooltip />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              {presentTypes.map((t) => (
                <Bar key={t} dataKey={t} stackId="a" fill={COLOR[t] || COLOR.Unknown} radius={[2, 2, 0, 0]} />
              ))}
            </BarChart>
          </ResponsiveContainer>
        </div>
      </Card>
    </div>
  );
}
